import React from 'react';
import { motion } from 'framer-motion';
import { bookInfoRo } from '../../../data/bookDataRo';
import SectionHeading from '../../SectionHeading';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const WhyMattersRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-4xl mx-auto px-6 lg:px-8">
      <SectionHeading title="De Ce Contează Această Carte" subtitle="Esența" />
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
        <p className="text-gray-300 leading-relaxed text-lg mb-6 text-center">
          <em>Trezirea Cuantică</em> este, în esență, o carte despre <span className="text-white font-semibold">ce costă să supraviețuiești ție însuți</span> — și ce devine posibil când reușești. Nu pretinde că urcușul a fost curat.
        </p>
        <p className="text-gray-400 leading-relaxed text-center mb-10">
          Cele 7,4 miliarde de oameni pierduți între apogeul Pământului din 2058 și populația sa de 3 miliarde din 2501 nu sunt statistici — sunt profesori din Kinshasa, fermieri mergând spre Mumbai inundată, ingineri de apă murind de deshidratare în timp ce îi salvau pe alții.
        </p>
        <div className="bg-brand-surface border border-brand-accent/20 rounded-2xl p-8 md:p-12 text-center box-glow mb-10">
          <p className="text-2xl md:text-3xl font-display font-bold text-white leading-relaxed mb-4">
            "{bookInfoRo.closingQuote}"
          </p>
          <p className="text-gray-500 text-sm">— cuvintele de închidere ale cronicii</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href={bookInfoRo.links.amazon.kindle} target="_blank" rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-brand-accent text-brand-dark rounded-lg font-bold hover:bg-brand-accentHover transition-colors">
            Citește Acum <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WhyMattersRo;